function sanitizeNumeralInput(v: string): number {
  let newValue = v;

  const hasComma = newValue.includes(",");
  const hasSeveralComma = newValue.split(",").length >= 3;
  const hasPeriod = newValue.includes(".");
  const hasSeveralPeriod = newValue.split(".").length >= 3;
  const hasWhitespace = newValue.includes(" ");
  const hasCommaBeforePeriod = newValue.indexOf(",") < newValue.indexOf(".");

  if (hasWhitespace) newValue = newValue.replaceAll(" ", "");
  if (hasComma && hasPeriod) {
    if (hasCommaBeforePeriod) newValue = newValue.replaceAll(",", "");
    else {
      newValue = newValue.replaceAll(".", "");
      newValue = newValue.replaceAll(",", ".");
    }
  } else if (hasComma) {
    newValue = hasSeveralComma
      ? newValue.replaceAll(",", "")
      : newValue.replaceAll(",", ".");
  } else if (hasSeveralPeriod) newValue = newValue.replaceAll(".", "");

  return +newValue || 0;
}

export {sanitizeNumeralInput};
